/**
 * 今の言語の辞書を持つ場所。起動時（main.tsx）に1回だけ入れ、アプリ本体を読み込む前に確定させる。
 * `TEXT`（config/strings.ts）は多くのファイルが import 時に取り込むので、途中で差し替えない（切り替えは再読み込み）。
 */
import type { LanguageId } from '../languages';
import type { Dictionary } from './dictionary';

let active: { id: LanguageId; dictionary: Dictionary } | null = null;

export function setActiveDictionary(id: LanguageId, dictionary: Dictionary): void {
  active = { id, dictionary };
}

export function activeDictionary(): Dictionary {
  if (!active) throw new Error('辞書が読み込まれていません。main.tsx（テストは tests/setup）で setActiveDictionary を先に呼ぶ');
  return active.dictionary;
}

/** 今の言語。画面の選択肢の「選んでいる言語」に使う */
export function activeLanguageId(): LanguageId {
  if (!active) throw new Error('辞書が読み込まれていません。main.tsx（テストは tests/setup）で setActiveDictionary を先に呼ぶ');
  return active.id;
}
